const gatewayUrl = 'https://dev-tggsp-search.search.windows.net/indexes/';

export const environment = {
  production: false,
  apiUrl:
    `${gatewayUrl}` + 'dev-sikhri-bani-sql-index/docs',
    apiUrl2:
    `${gatewayUrl}` + 'dev-sggs-2-0-search-tags-index/docs',
  apiLandingUrl:
    `${gatewayUrl}` + 'dev-sikhri-banilanding-search-sql-index/docs',
  apiWordsUrl:
    `${gatewayUrl}` + 'dev-sikhri-significantwords-sql-index/docs',
  apiBaniSubsectionUrl:
    `${gatewayUrl}` + 'dev-sggs2-0-banidetail-index/docs',
  apiSiteCarousel:
    `${gatewayUrl}` + 'dev-sggs2-0-sikhrievents-index/docs',
  apiBaniDashboard:
    `${gatewayUrl}` + 'dev-sggs2-0-banidetail-index/docs',
    apiDictionary: `${gatewayUrl}` + 'dev-sikhri-baniwordrefdict-sql-index/docs',
  apiKey: 'cYQHVB1YmZfFuvCLQbAZ3DBDPGv4HzLfTGjSJ4Q9B7AzSeD4ToTi',
  apiWordInstance:
  `${gatewayUrl}` + 'sikhri-banisubsection-sql-index/docs',
  apiFootnotesUrl:
    `${gatewayUrl}` + 'dev-sikhri-banifootnote-sql-index/docs',
  apiTeamUrl:
    `${gatewayUrl}` + 'dev-sggs2-0-teampageuserdetails-index/docs',    
  apiProjectSikhUrl:
    `${gatewayUrl}` + 'dev-sggs2-0-projectpage-teamuserdetails-index/docs',   
    baseUrl:'https://devsikhriservices.azurewebsites.net/api/ggsp2/',
  smtpEmailUrl:  `https://testsikhriservices.azurewebsites.net`,
  baniUrl: 'https://devsikhriservices.azurewebsites.net/',
  apiVersion: '2024-03-01-preview',
  apiVersionPreview: '2023-07-01-Preview',
  apiAuthorizationKey: 'YjRjMjVjM2QtNDE5ZS00YTgyLThjNjAtNjIzNzU3YmQ5NWIyOjRhNTAzYzNlLWNmYWQtNDk4YS1iMmEzLWFiZGMyNDU0OGU0NA==',
  apiAuthorizationtoken: 'MDJkYTk2MjMtYmZjZi00NjNhLWFkMjgtNWU5YzMzYzU3NDEwOjgxMjEwMGZiLTI5NGItNGI4Yy04Y2NjLTY2ZDA2N2UzMjQxNg==',
  pageClass:'dark',
  staticPageBanner:'Banner-dark-1440x250.webp',
  staticPageBannerMobile:'Banner-mobile-dark-393x250.webp',
};
